import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css, keyframes } from '@emotion/react';
import { useCallback, useState } from 'react';
import { useInstanceId } from '../../../context/instance/instanceContext';
import { clearTransitionAnimation } from '../../../redux/actions/transitionAnimationActions';
import { useAppDispatch } from '../../../redux/store';
import { TRANSITION_ANIMATION_ARIA_LABEL, TRANSITION_ANIMATION_COLORS, TRANSITION_CONTAINER_Z_INDEX, TRANSITION_HALF_DURATION_MS } from './transitionAnimationStyles';
import { getTransitionAnimationMaxCircleDiameterPx } from './transitionLoadingAnimation';
import { TransitionMessageDisplay } from './transitionMessageDisplay';
const CONTAINER_CSS = css `
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: ${TRANSITION_CONTAINER_Z_INDEX};
  overflow: hidden;
`;
export const TransitionEndingAnimation = ({ transition }) => {
    const instanceId = useInstanceId();
    const [maxCircleDiameterPx] = useState(getTransitionAnimationMaxCircleDiameterPx(instanceId));
    const dispatch = useAppDispatch();
    const { transitionAnimationMessage } = transition;
    const onAnimationEnd = useCallback(() => {
        dispatch(clearTransitionAnimation());
    }, [dispatch]);
    const keyframesName = keyframes `
    0% {
      width: ${maxCircleDiameterPx}px;
      height: ${maxCircleDiameterPx}px;
    }
    50% {
      width: ${maxCircleDiameterPx}px;
      height: ${maxCircleDiameterPx}px;
    }
    100% {
      width: 0;
      height: 0;
    }
  `;
    return (_jsxs("div", { css: CONTAINER_CSS, children: [TRANSITION_ANIMATION_COLORS.map((color, i) => (_jsx("div", { css: css `
            width: ${maxCircleDiameterPx}px;
            height: ${maxCircleDiameterPx}px;
            position: absolute;
            background-color: ${color};
            border-radius: 50%;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            animation: ${keyframesName} ${TRANSITION_HALF_DURATION_MS}ms ease-in forwards;
            animation-delay: ${Math.round(((TRANSITION_ANIMATION_COLORS.length - i) * TRANSITION_HALF_DURATION_MS) / 20)}ms;
          `, "aria-label": TRANSITION_ANIMATION_ARIA_LABEL, onAnimationEnd: i === 0 ? onAnimationEnd : undefined }, i))), _jsx(TransitionMessageDisplay, { transitionAnimationMessage: transitionAnimationMessage })] }));
};
